export default __webpack_public_path__ + "static/drivescore-favicon-32dfbc249c8a4167aee5dec9b4646aec.ico";